import { NICHE_PROFILES, getNicheProfile } from '../../data/businessNicheDirectory';

export { NICHE_PROFILES };

export const SCALE_MULTIPLIERS = [1, 2, 3, 5];

export const DEFAULT_SCALE_INPUTS = {
  budget: 150000,
  leads: 50,
  conv: 20,
  check: 25000,
  niche: 'local_service',
};

export const clampNumber = (value, min, max = Number.MAX_SAFE_INTEGER) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return min;
  return Math.min(max, Math.max(min, parsed));
};

export const formatMoney = (value, locale = 'ru-RU') => {
  if (!Number.isFinite(value)) return '—';
  return `${Math.round(value).toLocaleString(locale)} ₸`;
};

export const formatCount = (value, locale = 'ru-RU') => {
  if (!Number.isFinite(value)) return '—';
  return Math.round(value).toLocaleString(locale);
};

export const formatPercent = (value, digits = 1) => {
  if (!Number.isFinite(value)) return '—';
  const sign = value >= 0 ? '+' : '';
  return `${sign}${value.toFixed(digits)}%`;
};

export const getNicheCplGrowthPercent = (nicheId, mult) => {
  const profile = getNicheProfile(nicheId) || getNicheProfile('local_service');
  const factor = profile.cplFactors[mult] ?? profile.cplFactors[5] ?? 1;
  return Math.round((factor - 1) * 100);
};

export const calculateScaleScenarios = (inputs) => {
  const budget = clampNumber(inputs.budget, 1);
  const leads = clampNumber(inputs.leads, 1);
  const conv = clampNumber(inputs.conv, 0.1, 100) / 100;
  const check = clampNumber(inputs.check, 1);
  const niche = getNicheProfile(inputs.niche) ? inputs.niche : 'local_service';
  const profile = getNicheProfile(niche);

  const cplBase = budget / leads;

  const scenarios = SCALE_MULTIPLIERS.map((mult) => {
    const newBudget = budget * mult;
    const cplFactor = profile.cplFactors[mult] ?? profile.cplFactors[5];
    const cpl = cplBase * cplFactor;
    const newLeads = cpl > 0 ? newBudget / cpl : 0;
    const sales = newLeads * conv;
    const revenue = sales * check;
    const romi = newBudget > 0 ? ((revenue - newBudget) / newBudget) * 100 : 0;
    const leadsGrowth = leads > 0 ? ((newLeads - leads) / leads) * 100 : 0;
    const cplGrowth = cplBase > 0 ? ((cpl - cplBase) / cplBase) * 100 : 0;

    return {
      mult,
      budget: newBudget,
      cpl,
      cplFactor,
      leads: newLeads,
      leadsGrowth,
      cplGrowth,
      revenue,
      romi,
      sales,
    };
  });

  return { cplBase, budget, leads, conv, check, niche, profile, scenarios };
};

export const getScaleInsight = (scenarios) => {
  const x3 = scenarios.find((s) => s.mult === 3) || scenarios[scenarios.length - 1];

  if (x3.romi < 0) {
    return { text: `При масштабе ×3 ROMI ${Math.round(x3.romi)}% — реклама не окупается при текущих вводных. Сначала улучшите конверсию или чек.` };
  }

  if (x3.cplGrowth > 40) {
    return {
      text: `При ×3 лиды +${Math.round(x3.leadsGrowth)}%, но CPL +${Math.round(x3.cplGrowth)}% — рост дорогой. Масштабируйте постепенно.`,
    };
  }

  return {
    text: `При ×3 ожидаемо +${Math.round(x3.leadsGrowth)}% лидов при CPL +${Math.round(x3.cplGrowth)}%. Следите за ROMI по неделям.`,
  };
};

export const HOW_STEPS = [
  { num: '1', title: 'Каждый пункт имеет вес.', text: '«Да» = 100% балла, «Частично» = 50%, «Нет» = 0%. Итог — сумма взвешенных баллов.' },
  { num: '2', title: 'Пороги готовности:', text: 'до 50% — рано, 50–79% — доработать, 80%+ — можно запускать тест.' },
  { num: '3', title: 'Список «Сделать в первую очередь»', text: 'показывает пункты с ответом «Нет» и «Частично» по приоритету веса.' },
];
